import { render, staticRenderFns } from "./Step.vue?vue&type=template&id=ddcd8e5c&scoped=true"
import script from "./Step.vue?vue&type=script&lang=ts"
export * from "./Step.vue?vue&type=script&lang=ts"
import style0 from "./Step.vue?vue&type=style&index=0&id=ddcd8e5c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddcd8e5c",
  null
  
)

export default component.exports